import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconHighlightsStyle0 = cosmosIconCss;

const CosmosIconHighlights$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHighlights extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '116ad14073918ca23f877996a58b701f27474e3a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6b17f4affa97231f666d0d6daadd9032127a471e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b21c96e368aee65dd5aed732f2cce94f7b901f98', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.15 4.15a.49.49 0 0 0-.36-.15H6.26a.52.52 0 0 0-.35.14L2.32 7.68a.5.5 0 0 0 0 .67l8.38 10.27a.4.4 0 0 0 .62 0l8.4-10.27a.5.5 0 0 0 0-.67l-3.57-3.53Zm-5.9 11.56L4.71 9l5.54.69v6.02Zm1.5-6.1 5.66-.81-5.66 6.92V9.61ZM18 8.13v-.06.06ZM15.38 5.5l1.82 1.82-5.45.77V5.5h3.63Zm-8.71 0h3.58v2.63l-5.54-.7L6.67 5.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconHighlightsStyle0; }
}, [1, "cosmos-icon-highlights", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-highlights"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-highlights":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHighlights$1);
            }
            break;
    } });
}

const CosmosIconHighlights = CosmosIconHighlights$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHighlights, defineCustomElement };
